import React from 'react';
import { Bar } from 'react-chartjs-2';

type Props = {
  data: Array<any>;
};

export default function SurfaceReportGraph({ data }: Props) {
  const sortAndGroupByAxle = (data: any) => {
    return data
      .sort((a: any, b: any) => (a.axle < b.axle ? -1 : 1))
      .reduce((object: any, curr: any) => {
        if (!object[curr.axle]) {
          object[curr.axle] = [];
        }

        object[curr.axle].push(curr);

        return object;
      }, {});
  };

  const sortAndGroupByProduct = (data: any) => {
    return data
      .sort((a: any, b: any) => (a.product < b.product ? -1 : 1))
      .reduce((object: any, curr: any) => {
        if (!object[curr.product]) {
          object[curr.product] = [];
        }

        object[curr.product].push({
          ...curr,
          detrition_per_1000km_median: curr.detrition_per_km_median * 1000,
        });

        return object;
      }, {});
  };

  let sortedByAxle = sortAndGroupByAxle(data);
  let sortedByProduct = sortAndGroupByProduct(data);

  let borderColors = [
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(54, 162, 235)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)',
  ];
  let backgroundColors = [
    'rgba(255, 99, 132, 0.2)',
    'rgba(255, 159, 64, 0.2)',
    'rgba(255, 205, 86, 0.2)',
    'rgba(75, 192, 192, 0.2)',
    'rgba(54, 162, 235, 0.2)',
    'rgba(153, 102, 255, 0.2)',
    'rgba(201, 203, 207, 0.2)',
  ];

  return (
    <Bar
      height={300}
      legend={{
        position: 'top',
        labels: {
          boxWidth: 12,
        },
      }}
      options={{
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'mm per 1000 km',
              },
            },
          ],
        },
      }}
      data={{
        labels: Object.keys(sortedByAxle).map((axle: any) => `Akseli ${axle}`),
        datasets: Object.keys(sortedByProduct).map(
          (key: any, index: number) => {
            return {
              label: key,
              backgroundColor: backgroundColors[index],
              hoverBackgroundColor: borderColors[index],
              borderColor: borderColors[index],
              borderWidth: 1,
              data: sortedByProduct[key].reduce(
                (axleDataShell: any, p: any) => {
                  axleDataShell[
                    Object.keys(sortedByAxle).indexOf(p.axle.toString())
                  ] = p.detrition_per_1000km_median;
                  return axleDataShell;
                },
                new Array(Object.keys(sortedByAxle).length).fill(null)
              ),
            };
          }
        ),
      }}
    />
  );
}
